import {createAction} from 'redux-actions'

export const update = createAction('FEATURES/UPDATE', features => Array.isArray(features) ? features : [features])
export const fetch = createAction('FEATURES/FETCH')
export const fetchWithoutLoader = createAction('FEATURES/FETCH_WITHOUT_LOADER')